"use client"

import { useRef, type ComponentProps, type ElementRef } from "react"
import clsx from "clsx"

import * as css from "./styles.css"

/**
 * @description A component that dynamically set the top property of the container when the screen is smaller than the content
 * @example A ProductHeader with product details and accordion see https://fashion.jeanpaulgaultier.com/fr-fr/products/la-robe-rose-lurex
 * */
function DynamicStickyClient({ children, className }: ComponentProps<"div">) {
  const ref = useRef<ElementRef<"div">>(null)

  return (
    <div
      data-comp="Abstracts/DynamicStickyClient"
      ref={ref}
      style={{
        top: "57px",
      }}
      className={clsx(css.DynamicSticky, className)}
    >
      {children}
    </div>
  )
}

export default DynamicStickyClient
